// frontend/src/components/pages/AdminManualBoxLinesPage.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import ManualBoxLinesTable from '../tables/ManualBoxLinesTable';
import ManualBoxLineForm from '../common/ManualBoxLineForm';
import useManualControl from '../../hooks/useManualControl';

export default function AdminManualBoxLinesPage() {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);
  const { control, error } = useManualControl();
  const reload = useCallback(async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/boxlines/manual/active`,
    );
    setRows(data);
    setEditing((selected) =>
      selected ? (data.find((row) => row.id === selected.id) ?? null) : null,
    );
  }, []);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/boxlines/manual/active`,
        );
        if (active) {
          setRows(data);
          setEditing((selected) =>
            selected
              ? (data.find((row) => row.id === selected.id) ?? null)
              : null,
          );
        }
      } catch (err) {
        console.error(err);
      }
    };
    refresh();
    const timer = setInterval(refresh, 5000);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, []);
  const handleSuccess = () => {
    setEditing(null);
    reload().catch(console.error);
  };
  return (
    <div className='max-w-6xl mx-auto p-6 text-center'>
      <h2 className='text-lg font-bold'>수동 박스라인 관리</h2>
      {error && <p role='status'>{error}</p>}
      <ManualBoxLinesTable
        rowsProp={rows}
        selectedId={editing?.id}
        onSelect={setEditing}
        onDeleted={() => setEditing(null)}
        control={control}
        onStrategyChanged={handleSuccess}
      />
      <ManualBoxLineForm
        sessionDate={control?.session_date}
        control={control}
        editingRecord={editing}
        clearEditing={() => setEditing(null)}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
